import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class PagesToNavigateService{
    pages$: BehaviorSubject<{url: string, icon: string, title: string}[]> =
      new BehaviorSubject([
        {
            url: '/dashboard',
            icon: 'home-outline',
            title: 'Inicio'
        }
      ]);
  }